export default __webpack_public_path__ + "static/media/find.a6baca66.svg";